import script from "./multiResverationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./multiResverationTable.vue?vue&type=script&setup=true&lang=js"

import "./multiResverationTable.vue?vue&type=style&index=0&id=7dc0ca80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc0ca80"]])

export default __exports__